<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>
        {{ $t('tslOrders.assignmentDialog.title') }}
        <v-spacer />
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selectedUser"
          :items="users"
          :loading="loading"
          item-text="displayName"
          item-value="id"
          return-object
          :label="$t('tslOrders.assignmentDialog.selectEmployee')"
          clearable
          outlined
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }} {{ item.surname }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="closeDialog">
          {{ $t('tslOrders.assignmentDialog.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          :loading="saving"
          :disabled="!selectedUser"
          @click="saveAssignment"
        >
          {{ $t('tslOrders.assignmentDialog.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from '@/services'

export default {
  name: 'ChangeAssignmentDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: null
    },
    currentAssignedUserId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      saving: false,
      users: [],
      selectedUser: null
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    dialog (val) {
      if (val) {
        this.loadUsers()
      } else {
        this.selectedUser = null
      }
    }
  },
  methods: {
    async loadUsers () {
      this.loading = true
      try {
        const companyId = this.$store.getters.userCommonData.companyId
        const { data } = await Service.get('/Company/GetCompanyUsers', {
          companyId: companyId
        })

        // Add displayName for autocomplete
        this.users = data.map(user => ({
          ...user,
          displayName: `${user.name} ${user.surname}`
        }))

        // Pre-select current assigned user
        if (this.currentAssignedUserId) {
          this.selectedUser = this.users.find(u => u.id === this.currentAssignedUserId)
        }
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error loading users')
      } finally {
        this.loading = false
      }
    },
    async saveAssignment () {
      if (!this.selectedUser || !this.orderId) return

      this.saving = true
      try {
        await Service.put('/TSLOrder/ChangeAssignment', {
          orderId: this.orderId,
          newAssignedUserId: this.selectedUser.id
        })

        this.$store.dispatch('setSuccessNotification', this.$t('tslOrders.messages.assignmentChanged'))
        this.$emit('saved')
        this.closeDialog()
      } catch (e) {
        this.$store.dispatch('setErrorNotification',
          e.response?.data || this.$t('tslOrders.messages.assignmentChangeFailed'))
      } finally {
        this.saving = false
      }
    },
    closeDialog () {
      this.$emit('close')
      this.dialog = false
    }
  }
}
</script>
